export default function Warnings(){
return(
    <div className="flex " >
            <p className="text-start font-semibold min-w-fit page_pera_font_size" >Warnings : </p>
            {/* <div className="flex gap-2 items-center" >
            <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                Animal testing
            </span>
            <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                USDA
            </span>
            <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                Vegan
            </span>
             <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                Baby products

            </span>
            </div> */}
            </div>
)
}